import { HttpErrorResponse } from "@angular/common/http";
import { createAction, props } from "@ngrx/store";
import {
  SchedulePayload,
  ScheduleTopic,
} from "src/app/shared/interfaces/course-schedule";
import { Guid } from "src/app/shared/types/guid";

export const editTopicSchedulePrefix = "[Edit Topic Schedule]";

const editTopicScheduleActions = {
  request: `${editTopicSchedulePrefix} Load`,
  requestSuccess: `${editTopicSchedulePrefix} Load success`,
  requestFail: `${editTopicSchedulePrefix} Load fail`,
};

export const editTopicScheduleLoad = createAction(
  editTopicScheduleActions.request,
  props<{
    CourseId: Guid;
    GroupId: Guid;
    TopicId: Guid;
    schedule: SchedulePayload;
  }>(),
);

export const editTopicScheduleLoadSuccess = createAction(
  editTopicScheduleActions.requestSuccess,
  props<{ schedule: ScheduleTopic }>(),
);

export const editTopicScheduleLoadFailure = createAction(
  editTopicScheduleActions.requestFail,
  props<{ error: HttpErrorResponse }>(),
);
